module.exports = __webpack_public_path__ + "img/introduce-1.11fd2f9.png";